import script from "./UiViewToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./UiViewToggle.vue?vue&type=script&setup=true&lang=js"

import "./UiViewToggle.vue?vue&type=style&index=0&id=8353e04c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8353e04c"]])

export default __exports__